import { useCallback } from 'react'

import { stringToBoolean } from '../utils'
import { useLocalStorage } from './useLocalStorage'
import { useStorage } from './useStorage'

/**
 * Позволяет управлять тултипами, которые должны появиться `n` раз
 *
 * Ведется подсчет закрытия тултипов. Данные сохраняются в localStorage для персистентности
 *
 * Должен использоваться в паре с {@link useShowCountableTooltip}
 *
 * @param countIdentifier Часть ключа для localStorage.
 * Форматируется в `countShow${countIdentifier}Tooltip` и `show${countIdentifier}Tooltip`
 * @returns Флаг того, показывается или тултип и функция закрытия тултипа
 */
export const useCountableTooltip = (countIdentifier: string) => {
  const [, setCountShowTooltip] = useStorage(
    `countShow${countIdentifier}Tooltip`,
    Number,
    String,
    0,
  )
  const [isTooltipShown, setIsTooltipShown] = useLocalStorage(
    `show${countIdentifier}Tooltip`,
    stringToBoolean,
    String,
    false,
  )

  const closeTooltip = useCallback(() => {
    if (isTooltipShown) {
      setCountShowTooltip(prev => prev + 1)
    }
    setIsTooltipShown(false)
  }, [isTooltipShown, setCountShowTooltip, setIsTooltipShown])

  return { isTooltipShown, closeTooltip }
}
